import { useQuery } from 'react-query';
import { getIntercomAuthToken } from '../api/intercomApi';
import { ENABLE_INTERCOM_TOKEN } from '../../constants';

export const intercomQueries = {
  base: () => ({ queryKey: ['intercom'] }),
  token: () => ({
    queryKey: [...intercomQueries.base().queryKey, 'token'],
    queryFn: () => getIntercomAuthToken(),
  }),
};

export function useGetIntercomToken() {
  return useQuery({
    ...intercomQueries.token(),
    refetchOnWindowFocus: false,
    enabled: ENABLE_INTERCOM_TOKEN
  });
}
